import { Box, useMediaQuery, useTheme } from '@mui/material'

import { useStyles } from '../../styles'
import { TextTag } from 'src/components/text-tag'
import { EPromptsGlobalImageVariables, EPromptsGlobalVariables } from 'src/constants'
import { GlobalSettingsVariablesImageItem } from './global-variables-images.component'
import { ISettingsImagesPayload, IUpdateSettingsImagesPayloadDto } from 'src/types'
import { useState } from 'react'
import { EditImageVariableModal } from './edit-image-variable-modal.component'
import { useUpdateImagesPayload } from 'src/hooks/settings/use-update-images-payload.hook'

interface ISettingsVariablesItem {
  variable: string
}

export const GlobalSettingsVariablesItem = ({ variable }: ISettingsVariablesItem) => {
  const theme = useTheme()
  const isTablet = useMediaQuery(theme.breakpoints.down('tablet'))
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <TextTag
        label={variable}
        bgColor={theme.palette.custom.lightGreen}
        color={theme.palette.custom.darkBlue2}
        fontSize={isTablet ? '12px' : '14px'}
        size="medium"
        sx={{ fontWeight: 500, fontStyle: 'italic' }}
      />
    </Box>
  )
}

interface IGlobalSettingsVariablesProps {
  images: ISettingsImagesPayload | undefined
}

export const GlobalSettingsVariables = ({ images }: IGlobalSettingsVariablesProps) => {
  const [image, setImage] = useState<null | IUpdateSettingsImagesPayloadDto>(null)

  const { mutateAsync: updateImagesPayload, isLoading: isImagesPayloadLoading } =
    useUpdateImagesPayload()

  const theme = useTheme()
  const classes = useStyles()

  const handleCloseModal = () => {
    setImage(null)
  }

  const handleImageUpdate = async (newImage: IUpdateSettingsImagesPayloadDto) => {
    await updateImagesPayload(newImage)

    setImage(null)
  }

  const getImageUrl = (variable: EPromptsGlobalImageVariables) => {
    switch (variable) {
      case EPromptsGlobalImageVariables.IMAGE_1:
        return images?.image_1 || ''
      case EPromptsGlobalImageVariables.IMAGE_2:
        return images?.image_2 || ''
      case EPromptsGlobalImageVariables.IMAGE_3:
        return images?.image_3 || ''
      case EPromptsGlobalImageVariables.IMAGE_4:
        return images?.image_4 || ''
      case EPromptsGlobalImageVariables.IMAGE_5:
        return images?.image_5 || ''
      default:
        return ''
    }
  }
  return (
    <>
      <Box
        sx={{
          bgcolor: theme.palette.custom.lightGreen,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '10px',
        }}
      >
        <h3 className={classes.itemGroupTitle}>Global Variables</h3>

        <h5 className={classes.itemGroupSubtitle}>Trend Variables</h5>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            width: '100%',
            gap: '8px',
            flexWrap: 'wrap',
          }}
        >
          {Object.values(EPromptsGlobalVariables).map((variable) => (
            <GlobalSettingsVariablesItem key={variable} variable={variable} />
          ))}
        </Box>

        <h5 className={classes.itemGroupSubtitle}>Image Variables</h5>

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            width: '100%',
            gap: '16px',
            flexWrap: 'wrap',
            p: '0 8px',
          }}
        >
          {Object.values(EPromptsGlobalImageVariables).map((variable) => (
            <GlobalSettingsVariablesImageItem
              key={variable}
              variable={variable}
              imageUrl={getImageUrl(variable)}
              setImage={setImage}
              // handleUpdate={handleUpdateGlobalImage.bind(null, {
              //   field: variable,
              //   value: getImageUrl(variable),
              // })}
            />
          ))}
        </Box>
      </Box>
      <EditImageVariableModal
        onSave={handleImageUpdate}
        image={image!}
        open={!!image}
        handleCloseModal={handleCloseModal}
        isLoading={isImagesPayloadLoading}
      />
    </>
  )
}
